import { Link, SxProps } from '@mui/material';
import { PatternFormat } from 'react-number-format';

import colors from '../../../constants/colors';

const PhoneNumberLink = (props: {
  formattedPhoneNumber?: string;
  onClick?: Function;
  phoneNumber?: string;
  sx?: SxProps;
}) => {
  const { formattedPhoneNumber, onClick, phoneNumber } = props;

  return (
    <Link
      aria-label="Call Agent"
      data-testid="PhoneNumberLink"
      href={`tel:${phoneNumber}`}
      onClick={(e) => {
        if (onClick) {
          onClick(e);
        }
      }}
      sx={{
        color: colors.csaaSpectrumBlue50,
        textDecoration: 'none',
        fontWeight: 700,
        lineHeight: '17px',
        fontSize: { mobile: 16, tablet: 18 },
        width: 'fit-content',
        ...props.sx,
      }}
    >
      <PatternFormat
        value={formattedPhoneNumber || phoneNumber}
        displayType="text"
        format="###.###.####"
      />
    </Link>
  );
};

export default PhoneNumberLink;
